import request from '@/utils/request'
// 新增编辑设备
export function txDevice(query) {
  return request({
    url: '/api/deviceInfo/txDevice',
    method: 'post',
    data: query
  })
}
// 设备列表查询
export function qryDeviceInfo(query) {
  return request({
    url: '/api/deviceInfo/qryDeviceInfo',
    method: 'get',
    params: {
      did: query.did || null,
      fieldId: query.fieldId || null,
      identity: query.identity || null,
      address: query.address || null,
      binDingAgent: query.binDingAgent || null,
      binDingField: query.binDingField || null,
      notBinDingAgent: query.notBinDingAgent || null,
      notBinDingField: query.notBinDingField || null,
      state: query.state || null,
      pageIndex: query.pageIndex || null,
      pageSize: query.pageSize || null
    }
  })
}
// 箱子列表
export function qryBoxInfo(query) {
  return request({
    url: '/api/deviceInfo/qryBoxInfo',
    method: 'post',
    params: query
  })
}
// 清理箱子
export function clearBoxInfo(query) {
  return request({
    url: '/api/deviceInfo/clearBoxInfo',
    method: 'post',
    params: query
  })
}
/**
 * 清理箱子新接口
 * @param {*} data
 * @returns
 */
export function clearBoxInfo01(data) {
  return request({
    url: '/api/deviceInfo/clearBoxInfo01',
    method: 'post',
    data
  })
}
// 设备详情
export function deviceDetail(query) {
  return request({
    url: '/api/deviceInfo/deviceDetail',
    method: 'post',
    params: query
  })
}
// 删除箱子
export function deleteBox(query) {
  return request({
    url: '/api/deviceInfo/deleteBox',
    method: 'post',
    data: query.boxIds
  })
}
// 批量添加箱子
export function batchAddDeviceBox(query) {
  return request({
    url: '/api/deviceInfo/batchAddDeviceBox',
    method: 'post',
    data: query
  })
}

// POST /api/deviceInfo/batchAddDeviceBoxWeb web端 添加，编辑箱子
export function batchAddDeviceBoxWeb(data) {
  return request({
    url: '/api/deviceInfo/batchAddDeviceBoxWeb',
    method: 'post',
    data
  })
}

// 绑定场地
export function binDingField(query) { //  + '&dIds=' + JSON.stringify(query.dIds)?field=' + query.field
  return request({
    url: '/api/deviceInfo/binDingField',
    data: query,
    method: 'post'
  })
}
// 绑定代理商
export function binDingAgent(query) {
  return request({
    url: '/api/deviceInfo/binDingAgent',
    method: 'post',
    data: query
  })
}
// 设备使用详情(设备订单)
export function qryDeviceUseDetails(query) {
  return request({
    url: '/api/deviceInfo/qryDeviceUseDetails',
    method: 'post',
    params: query
  })
}
// 批量添加设备
export function batchAddDevice(query) {
  return request({
    url: '/api/deviceInfo/batchAddDevice',
    method: 'post',
    data: query
  })
}

// 修改设备状态
export function updateDeviceState(query) {
  return request({
    url: '/api/deviceInfo/updateDeviceState',
    method: 'post',
    params: query
  })
}

// 根据手机号获取箱子信息
export function qryUseBoxInfo(query) {
  return request({
    url: '/api/smallProgram/qryUseBoxInfo',
    method: 'post',
    params: query
  })
}

// GET /api/deviceInfo/qryDevice 查询设备
export function getDeviceData(query) {
  return request({
    url: '/api/deviceInfo/qryDevice',
    params: query
  })
}

/**
 *GET /api/deviceInfo/qryDeviceGroup 查询设备分组
 * @param {*} params
 * @returns
 */
export function qryDeviceGroup(params) {
  return request({
    url: '/api/deviceInfo/qryDeviceGroup',
    method: 'get',
    params
  })
}

/**
 *POST /api/deviceInfo/addDeviceGroup 添加设备分组
 * @param {*} data
 * @returns
 */
export function addDeviceGroup(data) {
  return request({
    url: '/api/deviceInfo/addDeviceGroup',
    method: 'post',
    data
  })
}

/**
 *POST /api/deviceInfo/modDeviceGroup 编辑设备分组
 * @param {*} data
 * @returns
 */
export function modDeviceGroup(data) {
  return request({
    url: '/api/deviceInfo/modDeviceGroup',
    method: 'post',
    data
  })
}

/**
 *POST /api/deviceInfo/setDeviceGroup 设置设备分组
 * @param {*} data
 * @returns
 */
export function setDeviceGroup(data) {
  return request({
    url: '/api/deviceInfo/setDeviceGroup',
    method: 'post',
    data
  })
}

// POST /api/deviceInfo/reboot 远程重启
export function reboot(params) {
  return request({
    url: '/api/deviceInfo/reboot',
    method: 'post',
    params
  })
}

